module.exports = __webpack_public_path__ + "img/icon-hs-gallery.2256d484.svg";